import Repository from "./Repository";
import TokenService from "../helpers/token";
const resource = `${Repository.defaults.baseUrlTutor}`;
const resourceAssetVh = `${process.env.VUE_APP_VH_ASSET_DOMAIN}/api/image/s3`

export default {
    async getListTicketApi(params = {}) {
        const response = await Repository.get(`ticket/ticket-template`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response;
    },
    async getTicketFieldsApi(params = {}) {
        const response = await Repository.get(`ticket/ticket-field`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response;
    },
    async getTicketSystemModuleApi(body = {}) {
        const response = await Repository.post(`ticket/system-module`,body ,{
            headers: TokenService.getHeader(),
        })
        return response;
    },
    async createTicketApi(body) {
        const response = await Repository.post(`/ticket`,body, {
            headers: TokenService.getHeader(),
        });
        return response;
    },
    async uploadImage(body) {
        const response = await Repository.post(`${resourceAssetVh}`,body, {
            // headers: {
            //     Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NTY3LCJlbWFpbCI6IkR1bmdicEBnbWFpbC5jb20iLCJpYXQiOjE3MDU5MTU1NzEsImV4cCI6MTcxMTA5OTU3MX0.iGgJHdlHNBf3WcbskIYiLwaqQJ5DciS62AXlX9cHXew`,
            // },
            headers: TokenService.getHeader(),
        });
        return response;
    },
    async getListTicketStatus() {
        const response = await Repository.get(`ticket/status`, {
            headers: TokenService.getHeader(),
        });
        return response;
    },
};
